import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptorConfiguration, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';
import { AuthInterceptor } from './http.interceptor';
import { SnackbarModule } from './components/snackbar/snackbar.module';
import { LoginFailedModule } from './pages/login-failed/login-failed.module';
import { HomeModule } from './pages/home/home.module';
import { ApmModule, ApmService } from '@elastic/apm-rum-angular'
import { ErrorHandler } from '@angular/core'
import { ApmErrorHandler } from '@elastic/apm-rum-angular';
import { AccessDeniedModule } from './pages/access-denied/access-denied.module';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function MsalInstanceFactory(): IPublicClientApplication {
  var instance = new PublicClientApplication({
    auth: {
      clientId: 'e854ad60-f2cb-4a15-99fd-d56be44ccc65',
      authority: "https://login.microsoftonline.com/ded25b0e-ac37-45dd-a4b4-f5c21ca02a18",
      redirectUri: environment.LRNEXT_APP_URL
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      tokenRenewalOffsetSeconds: 300
    }
  });
  return instance;
}


export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  //protectedResourceMap.set('https://graph.microsoft.com/v2.0/me', ['user.read']);
  protectedResourceMap.set(environment.LRNEXT_API_URL, ['api://1232ea29-afc9-4855-bbc8-9a44ba67efd8/Users.Read'])

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['api://1232ea29-afc9-4855-bbc8-9a44ba67efd8/Users.Read']
    },
    loginFailedRoute: '/login-failed'
  };
}


@NgModule({
  declarations: [AppComponent],
  imports: [
    ApmModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    // Vex
    VexModule,
    CustomLayoutModule,
    MatNativeDateModule,
    NgxMatNativeDateModule, 
    SnackbarModule,
    HomeModule,
    LoginFailedModule,
    AccessDeniedModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MsalInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    AuthService,
    ApmService,
    { provide: ErrorHandler, useClass: ApmErrorHandler }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
